import AxiosConfig from '../utils/AxiosConfig';

class MarketingPlanningService {
  async getCampaigns() {
    const response = await AxiosConfig.get('/marketing/planning/campaigns');
    return response.data?.data ?? response.data ?? [];
  }

  async getCampaign(id) {
    const response = await AxiosConfig.get(`/marketing/planning/campaigns/${id}`);
    return response.data?.data ?? response.data;
  }

  async createCampaign(payload) {
    const response = await AxiosConfig.post('/marketing/planning/campaigns', payload);
    return response.data?.data ?? response.data;
  }

  async updateCampaign(id, payload) {
    const response = await AxiosConfig.put(`/marketing/planning/campaigns/${id}`, payload);
    return response.data?.data ?? response.data;
  }

  async deleteCampaign(id) {
    const response = await AxiosConfig.delete(`/marketing/planning/campaigns/${id}`);
    return response.data?.data ?? response.data;
  }

  async createItem(campaignId, payload) {
    const response = await AxiosConfig.post(`/marketing/planning/campaigns/${campaignId}/items`, payload);
    return response.data?.data ?? response.data;
  }

  async updateItem(itemId, payload) {
    const response = await AxiosConfig.put(`/marketing/planning/items/${itemId}`, payload);
    return response.data?.data ?? response.data;
  }

  async deleteItem(itemId) {
    const response = await AxiosConfig.delete(`/marketing/planning/items/${itemId}`);
    return response.data?.data ?? response.data;
  }

  async validatePublication(itemId) {
    const response = await AxiosConfig.get(`/marketing/planning/items/${itemId}/publication/validation`);
    return response.data?.data ?? response.data;
  }

  async schedulePublication(itemId, payload = {}) {
    const response = await AxiosConfig.post(`/marketing/planning/items/${itemId}/publication/enqueue`, payload);
    return response.data?.data ?? response.data;
  }

  async uploadAsset(campaignId, file, options = {}) {
    const formData = new FormData();
    formData.append('file', file);
    const response = await AxiosConfig.post(`/marketing/planning/campaigns/${campaignId}/assets`, formData, {
      params: {
        role: options.role,
        itemId: options.itemId,
        aspectRatio: options.aspectRatio,
        sortOrder: options.sortOrder
      },
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data?.data ?? response.data;
  }

  async getIntegrations() {
    const response = await AxiosConfig.get('/marketing/planning/integrations');
    return response.data?.data ?? response.data ?? [];
  }

  async saveIntegration(provider, payload) {
    const response = await AxiosConfig.put(`/marketing/planning/integrations/${provider}`, payload);
    return response.data?.data ?? response.data;
  }

  async getIntegrationAuthUrl(provider, redirectUri) {
    const response = await AxiosConfig.get(`/marketing/planning/integrations/${provider}/auth-url`, {
      params: { redirectUri },
      skipGlobalErrorRedirect: true
    });
    const data = response.data?.data ?? response.data;
    if (data && data.configured === false) {
      throw new Error(data.errorMessage || 'No se pudo iniciar la conexión con Meta');
    }
    return data;
  }

  async connectIntegration(provider, payload) {
    const response = await AxiosConfig.post(`/marketing/planning/integrations/${provider}/connect`, payload, {
      skipGlobalErrorRedirect: true
    });
    return response.data?.data ?? response.data;
  }

  async disconnectIntegration(provider) {
    const response = await AxiosConfig.delete(`/marketing/planning/integrations/${provider}`);
    return response.data?.data ?? response.data;
  }
}

export default new MarketingPlanningService();
